import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PesosComponent} from "../../pesos.component";
import {WeightService} from "../../../../../../core/services/parameters/weight.service";

@Component({
  selector: 'confirm-delete',
  templateUrl: './confirm-delete-weight.component.html',
  styleUrls: ['./confirm-delete-weight.component.scss']
})
export class ConfirmDeleteWeightComponent implements OnInit {

  id: number;

  constructor(
    public dialogRef: MatDialogRef<PesosComponent>,
    private weightService: WeightService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
  }

  ngOnInit(): void {
    this.id = this.data.id;
  }

  submit() {
    if (this.id !== undefined || this.id !== null)
      this.weightService.deleteWeight(this.id).subscribe(_res => {
        this.dialogRef.close(true);
      });
  }

  onNoClick(b: boolean) {
    this.dialogRef.close(b);
  }
}
